import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zVehicleManufacturerSchemaDom, zVehicleManufacturerSchemaCreateDom, } from "@/types/vehicleManufacturer/vehicleManufacturer.domain";
import { zVehicleManufacturerSchemaDto, zVehicleManufacturerSchemaCreateDto, } from "@/types/vehicleManufacturer/vehicleManufacturer.dto";
export const VehicleManufacturerMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zVehicleManufacturerSchemaDom.parse(dto),
    domainToDto: (domain) => zVehicleManufacturerSchemaDto.parse(domain),
    dtoToCreateDto: (domain) => zVehicleManufacturerSchemaCreateDto.parse(domain),
    dtoToCreateDom: (dto) => zVehicleManufacturerSchemaCreateDom.parse(dto),
});
